import Vue from 'vue'
import Router from 'vue-router'
import MainView from './views/MainView.vue'
import Home from './views/Home.vue'
import About from './views/About.vue'
import HeroPet from './views/HeroPet.vue'
import HeroPetComment from './views/HeroPetComment.vue'
import FindBlood from './views/FindBlood.vue'
import Donation from './views/Donation.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: MainView,
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
          meta: { title: 'Home' }
        },
        {
          path: 'about',
          name: 'about',
          component: About,
          meta: { title: 'About' }
        },
        {
          path: 'hero-pet',
          name: 'heroPet',
          component: HeroPet,
          meta: { title: 'Heropet' }
        },
        {
          path: 'hero-pet/:petId',
          name: 'heroPetComment',
          component: HeroPetComment,
          meta: { title: 'Heropet Comment' }
        },
        {
          path: 'find-blood',
          name: 'findBlood',
          component: FindBlood,
          meta: { title: 'Find Blood' }
        },
        {
          path: 'donation',
          name: 'donation',
          component: Donation,
          meta: { title: 'Donation' }
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' | Smart Pet Blood Bank'
  } else {
    document.title = 'Smart Pet Blood Bank'
  }
  next()
})

export default router
